export const UPDATE_SEARCH_RESULT = "add-users";
export const REMOVE_USER_FROM_SEARCH_RESULT = "remove-user-from-search-result";
export const ADD_PERMISSION_INFORMATION_TO_USER = "add-permission-information-to-user";
export const SET_LOADING = "set-loading";
export const SET_INITIAL_LOADING = "set-initial-loading";
export const RESET_PEOPLE_MODULE = "reset-people-module";
